import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { makeApiCall } from '../../services/httpService';
import { BASE_URL } from '../../config';
import toast from 'react-hot-toast';
import DContext from '../../context/DContext';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import ContentLoader from '../loader/ContentLoader';
import { Button, Modal } from 'react-bootstrap';
import { useLoadingBar } from 'react-top-loading-bar';
import { formatSupplierInfo } from '../../helper/commonHelper';

const ListInventory = () => {
  const { start, complete } = useLoadingBar({ color: "blue", height: 2 });

  const [loading, setLoading] = useState(false);
  const [inventoryRes, setInventoryRes] = useState({
    paginationInfo: {},
    inventories: []
  });
  const [singleInventoryDetail, setSingleInventoryDetail] = useState();
  const [singleInventoryPNR, setSingleInventoryPNR] = useState();
  const [singleInventoryFlightStops, setSingleInventoryFlightStops] = useState();
  const [actionModal, setActionModal] = useState({
    show: false,
    type: null, // "edit" | "refresh" | "delete"
    inventory: null
  });

  const [editInventoryForm, setEditInventoryForm] = useState({
    dep_date: "",
    dep_time: "",
    arr_time: "",
    seat_quantity: ""
  });

  const [pageValue, setPageValue] = useState(1);
  const [pagingLimit, setPagingLimit] = useState("10");

  //Modal
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const openActionModal = (type, inventory) => {
    setActionModal({ show: true, type, inventory });

    if (type === "edit") {
      setEditInventoryForm({
        dep_date: inventory?.dep_date || "",
        dep_time: inventory?.dep_time || "",
        arr_time: inventory?.arr_time || "",
        seat_quantity: inventory?.seat_quantity ?? ""
      });
    }

    if (type === "refresh") {
      loadInventoryDetail(inventory?.inventory_id);
    }
  };

  const closeActionModal = () => {
    setActionModal({ show: false, type: null, inventory: null });
  };


  useEffect(() => {
    loadInventory();
  }, [pagingLimit, pageValue])

  const showSwal = (title, text, icon) => {
    withReactContent(Swal).fire({
      title,
      text,
      icon // 'success' | 'error' | 'warning' | 'info' | 'question'
    })
  }



  const loadInventory = async () => {
    try {

      setLoading(true);
      start();
      let apiUrl = `${BASE_URL}/api/inventory?&page=${pageValue}&limit=${pagingLimit}`;
      let apiRes = await makeApiCall("GET", null, apiUrl);
      console.log(apiRes);
      if (apiRes?.statusCode == 200) {
        //toast.success(apiRes.message);
        setInventoryRes({
          paginationInfo: apiRes.resData?.paginationInfo,
          inventories: apiRes.resData?.inventories
        })
      } else {
        console.log(apiRes?.response?.data?.message)
        if (apiRes?.response?.data?.message) {
          showSwal("Error", apiRes?.response?.data?.message, "error")
        } else {
          toast.error(apiRes.message);
        }
      }
    } catch (err) {
      console.log("Fatal Error", err);
      //toast.error("Something Went Wrong...");
      showSwal("Error", "Something went wrong...", "error")
    } finally {
      setLoading(false);
      complete();
    }
  }

  const loadInventoryDetail = async (inventoryId) => {
    try {
      setLoading(true);
      start();
      let apiUrl = `${BASE_URL}/api/inventory/${inventoryId}`;
      let apiRes = await makeApiCall("GET", null, apiUrl);
      console.log(apiRes);
      if (apiRes?.statusCode == 200) {
        //toast.success(apiRes.message);
        setSingleInventoryDetail(apiRes?.resData?.inventory);
        setSingleInventoryPNR(apiRes?.resData?.pnr_details);
        setSingleInventoryFlightStops(apiRes?.resData?.flight_stops);

      } else {
        console.log(apiRes?.response?.data?.message)
        if (apiRes?.response?.data?.message) {
          showSwal("Error", apiRes?.response?.data?.message, "error")
        } else {
          toast.error(apiRes.message);
        }
      }
    } catch (err) {
      console.log("Fatal Error", err);
      //toast.error("Something Went Wrong...");
      showSwal("Error", "Something went wrong...", "error")
    } finally {
      setLoading(false)
      complete();
    }
  }

  const handleEditInventoryField = (e) => {
    const { name, value } = e.target;
    setEditInventoryForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleActionSubmit = async () => {
    try {
      if (actionModal.type === "edit") {
        // TODO: connect PATCH API here
        console.log("Edit inventory payload:", {
          inventory_id: actionModal?.inventory?.inventory_id,
          ...editInventoryForm
        });
        toast.success("Edit form ready. Connect update API.");
      }

      if (actionModal.type === "refresh") {
        await loadInventory();
        toast.success("Inventory refreshed");
      }

      if (actionModal.type === "delete") {
        // TODO: connect DELETE API here
        console.log("Delete inventory id:", actionModal?.inventory?.inventory_id);
        toast.success("Delete modal working. Connect delete API.");
      }
    } catch (err) {
      showSwal("Error", "Something went wrong...", "error");
    } finally {
      closeActionModal();
    }
  };

  const handlePagingLimit = (e) => {
    setPageValue(1);
    setPagingLimit(e.target.value);
  }

  const handlePagination = (pageValueInput) => {
    setPageValue(pageValueInput);
  }


  const loadSuppliers = async (searchq = null) => {
    try {
      let apiUrl = `${BASE_URL}/api/utils/suppliers?page=1&limit=20`;
      let payload = {
        "agency_name": "",
        "head_person": "",
        "mobile": "",
        "email": ""
      }
      let apiRes = await makeApiCall("POST", payload, apiUrl);
      console.log(apiRes);
      if (apiRes?.statusCode == 200) {
        //toast.success(apiRes.message);
        return apiRes.resData.suppliers;
      } else {
        toast.error(apiRes.message);
      }
    } catch (err) {
      console.log("Fatal Error", err);
      //toast.error("Something Went Wrong...");
      showSwal("Error", "Something went wrong...", "error")
    }
  }


  const handleSelectChangeSupplier = (selectedOption) => {
    if (selectedOption) {
      console.log("Selected supplier:", selectedOption);
      // e.g., selectedOption.value (id), selectedOption.label (agency name)
    } else {
      console.log("Cleared selection");
    }
  };

  return (
    <>
      <section className="section dashboard">

        {/* ── Filter Card ── */}
        <div className="row mb-3">
          <div className="col-lg-12">
            <div className="card border-0 shadow-sm" style={{ borderRadius: "14px" }}>
              <div className="card-body py-3 px-4">

                {/* Row 1 */}
                <div className="row g-3 align-items-end mb-3">
                  <div className="col-md-3">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>
                      <i className="bi bi-geo-alt-fill me-1"></i> Departure City
                    </label>
                    <select className="form-select form-select-sm" id="DepartureCitySelect"
                      style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", fontSize: "13px", height: "38px" }}>
                      <option value="">Select</option>
                      <option value="patna">Patna</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>
                      <i className="bi bi-geo-fill me-1"></i> Arrival City
                    </label>
                    <select className="form-select form-select-sm" id="ArrivalCitySelect"
                      style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", fontSize: "13px", height: "38px" }}>
                      <option value="">Select</option>
                      <option value="mumbai">Mumbai</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>
                      <i className="bi bi-calendar-event me-1"></i> PNR Date From
                    </label>
                    <input type="date" className="form-control form-control-sm" id="pnrdatefrom"
                      style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", fontSize: "13px", height: "38px" }} />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>
                      <i className="bi bi-calendar-check me-1"></i> PNR Date To
                    </label>
                    <input type="date" className="form-control form-control-sm" id="pnrdateto"
                      style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", fontSize: "13px", height: "38px" }} />
                  </div>
                </div>

                {/* Row 2 */}
                <div className="row g-3 align-items-end">
                  <div className="col-md-3">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>
                      <i className="bi bi-building me-1"></i> Supplier
                    </label>
                    <AsyncSelect
                      cacheOptions
                      name="supplier_dropdown"
                      placeholder="Search supplier..."
                      loadOptions={loadSuppliers}
                      onChange={handleSelectChangeSupplier}
                      defaultOptions={true}
                      isClearable
                      isSearchable
                      styles={{
                        control: (base) => ({
                          ...base, borderRadius: "8px", border: "1.5px solid #dde3ef",
                          fontSize: "13px", minHeight: "38px", boxShadow: "none",
                          "&:hover": { borderColor: "#1a3a8f" }
                        })
                      }}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>
                      <i className="bi bi-upc me-1"></i> PNR Number
                    </label>
                    <div className="input-group input-group-sm">
                      <span className="input-group-text" style={{ background: "#eef0ff", border: "1.5px solid #dde3ef", borderRight: "none", borderRadius: "8px 0 0 8px" }}>
                        <i className="bi bi-upc" style={{ color: "#1a3a8f", fontSize: "12px" }}></i>
                      </span>
                      <input type="text" className="form-control form-control-sm" id="pnrnumber" placeholder="PNR Number"
                        style={{ border: "1.5px solid #dde3ef", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "white", fontSize: "13px", height: "38px" }} />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>
                      <i className="bi bi-airplane me-1"></i> Airline
                    </label>
                    <select className="form-select form-select-sm" id="AirLinesSelect"
                      style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", fontSize: "13px", height: "38px" }}>
                      <option value="">Select</option>
                      <option value="6E">Indigo (6E)</option>
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>
                      <i className="bi bi-hash me-1"></i> Flight Number
                    </label>
                    <div className="input-group input-group-sm">
                      <span className="input-group-text" style={{ background: "#eef0ff", border: "1.5px solid #dde3ef", borderRight: "none", borderRadius: "8px 0 0 8px" }}>
                        <i className="bi bi-hash" style={{ color: "#1a3a8f", fontSize: "12px" }}></i>
                      </span>
                      <input type="text" className="form-control form-control-sm" id="FlightNumber" placeholder="Flight No."
                        style={{ border: "1.5px solid #dde3ef", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "white", fontSize: "13px", height: "38px" }} />
                    </div>
                  </div>
                  <div className="col-md-1 d-flex align-items-end">
                    <button type="submit" className="btn btn-sm fw-semibold d-flex align-items-center gap-2 text-white w-100 justify-content-center"
                      style={{
                        background: "linear-gradient(135deg, #0f2557, #1a3a8f)",
                        borderRadius: "8px", border: "none",
                        boxShadow: "0 4px 12px rgba(15,37,87,0.25)",
                        height: "38px", fontSize: "13px"
                      }}>
                      <i className="fa-solid fa-magnifying-glass"></i> Search
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        {/* ── Table Card ── */}
        <div className="row">
          <div className="col-lg-12">
            <div className="card border-0 shadow-sm" style={{ borderRadius: "14px", position: "relative" }}>
              <div className="card-body pb-0 px-4 pt-3">

                {/* Card Header */}
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <div style={{
                      width: "34px", height: "34px", borderRadius: "9px",
                      background: "linear-gradient(135deg, #0f2557, #1a3a8f)",
                      display: "flex", alignItems: "center", justifyContent: "center"
                    }}>
                      <i className="bi bi-airplane-fill text-white" style={{ fontSize: "14px" }}></i>
                    </div>
                    <div>
                      <h6 className="mb-0 fw-bold" style={{ color: "#0f2557", fontSize: "14px" }}>Inventory List</h6>
                      <span style={{ fontSize: "11px", color: "#8a9ab5" }}>
                        Total: <strong style={{ color: "#1a3a8f" }}>{inventoryRes?.paginationInfo?.totalRecords ?? 0}</strong> records
                      </span>
                    </div>
                  </div>
                  <Link to="/inventory/add" style={{ textDecoration: "none" }}>
                    <button className="btn btn-sm fw-semibold d-flex align-items-center gap-2 text-white"
                      style={{
                        background: "linear-gradient(135deg, #0f2557, #1a3a8f)",
                        borderRadius: "8px", border: "none",
                        boxShadow: "0 4px 12px rgba(15,37,87,0.25)",
                        fontSize: "13px", height: "34px", padding: "0 16px"
                      }}>
                      <i className="bi bi-plus-circle-fill"></i> Add New PNR
                    </button>
                  </Link>
                </div>

                {/* Loading Overlay */}
                {loading && (
                  <div style={{
                    position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
                    background: "rgba(255,255,255,0.7)",
                    display: "flex", justifyContent: "center", alignItems: "center",
                    zIndex: 10, borderRadius: "14px"
                  }}>
                    <ContentLoader loaderType="circleSpin" />
                  </div>
                )}

                {/* Table */}
                <div className="table-responsive" style={{ height: "calc(100vh - 580px)" }}>
                  <table className="table table-hover mb-0" style={{ fontSize: "13px" }}>
                    <thead>
                      <tr style={{ background: "#f4f6fb" }}>
                        {["Supplier", "Departure", "Arrival", "Dept – Arr Time", "Airline (Flight No)", "PNR", "Dept. Date", "Seats", "Fare", "+/- Seat", "Action"].map((h, i) => (
                          <th key={i} style={{
                            fontSize: "11px", fontWeight: "700", color: "#8a9ab5",
                            textTransform: "uppercase", letterSpacing: "0.6px",
                            border: "none", padding: "10px 12px", whiteSpace: "nowrap",
                            background: "#f4f6fb"
                          }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {inventoryRes?.inventories?.length > 0 ? (
                        inventoryRes.inventories.map((inventory) => (
                          <tr
                            key={inventory?.inventory_id}
                            style={{ borderBottom: "1px solid #f0f2f8", verticalAlign: "middle" }}
                            onMouseEnter={(e) => (e.currentTarget.style.background = "#f8f9fe")}
                            onMouseLeave={(e) => (e.currentTarget.style.background = "")}
                          >
                            {/* Supplier */}
                            <td style={{ padding: "10px 12px" }}>
                              <div className="d-flex align-items-start gap-2">
                                <div
                                  style={{
                                    width: "26px",
                                    height: "26px",
                                    borderRadius: "7px",
                                    background: "#eef0ff",
                                    flexShrink: 0,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                  }}
                                >
                                  <i className="bi bi-building" style={{ fontSize: "11px", color: "#1a3a8f" }}></i>
                                </div>
                                <div>
                                  <div style={{ fontWeight: "700", color: "#0f2557", fontSize: "12px" }}>
                                    Inventory #{inventory?.inventory_id}
                                  </div>
                                  <div style={{ fontSize: "11px", color: "#6b7280" }}>
                                    {formatSupplierInfo(inventory?.supplier_info)}
                                  </div>
                                </div>
                              </div>
                            </td>

                            {/* Departure */}
                            <td style={{ padding: "10px 12px" }}>
                              <span style={{ fontWeight: "600", color: "#0f2557", fontSize: "12px" }}>
                                {inventory?.dep_city_name || "-"}
                              </span>
                              <span
                                style={{
                                  marginLeft: "4px",
                                  fontSize: "10px",
                                  fontWeight: "700",
                                  background: "#eef0ff",
                                  color: "#1a3a8f",
                                  borderRadius: "5px",
                                  padding: "1px 6px"
                                }}
                              >
                                {inventory?.dep_airport_code || "-"}
                              </span>
                            </td>

                            {/* Arrival */}
                            <td style={{ padding: "10px 12px" }}>
                              <span style={{ fontWeight: "600", color: "#0f2557", fontSize: "12px" }}>
                                {inventory?.arr_city_name || "-"}
                              </span>
                              <span
                                style={{
                                  marginLeft: "4px",
                                  fontSize: "10px",
                                  fontWeight: "700",
                                  background: "#eef0ff",
                                  color: "#1a3a8f",
                                  borderRadius: "5px",
                                  padding: "1px 6px"
                                }}
                              >
                                {inventory?.arr_airport_code || "-"}
                              </span>
                            </td>

                            {/* Dept – Arr Time */}
                            <td style={{ padding: "10px 12px", whiteSpace: "nowrap" }}>
                              <span style={{ fontSize: "12px", color: "#374151", fontWeight: "600" }}>
                                <i className="bi bi-clock me-1" style={{ color: "#8a9ab5", fontSize: "10px" }}></i>
                                {inventory?.dep_time || "-"}
                              </span>
                              <span style={{ margin: "0 4px", color: "#8a9ab5" }}>→</span>
                              <span style={{ fontSize: "12px", color: "#374151", fontWeight: "600" }}>
                                {inventory?.arr_time || "-"}
                              </span>
                            </td>

                            {/* Airline (Flight No) */}
                            <td style={{ padding: "10px 12px" }}>
                              <div className="d-flex align-items-center gap-2">
                                <img
                                  style={{
                                    width: "22px",
                                    height: "22px",
                                    borderRadius: "5px",
                                    objectFit: "contain",
                                    background: "#f4f6fb",
                                    padding: "2px"
                                  }}
                                  src={`https://images.kiwi.com/airlines/32/${inventory?.airline_code}.png`}
                                  alt={inventory?.airline_code || "airline"}
                                />
                                <div>
                                  <div style={{ fontWeight: "700", color: "#374151", fontSize: "12px", lineHeight: 1.1 }}>
                                    {inventory?.airline_name || "-"}
                                  </div>
                                  <div style={{ fontSize: "11px", color: "#6b7280" }}>
                                    {inventory?.flight_number || "-"}
                                  </div>
                                </div>
                              </div>
                            </td>

                            {/* PNR */}
                            <td style={{ padding: "10px 12px" }}>
                              <span
                                style={{
                                  background: "#f4f6fb",
                                  color: "#0f2557",
                                  borderRadius: "6px",
                                  padding: "3px 8px",
                                  fontSize: "11px",
                                  fontWeight: "700",
                                  fontFamily: "monospace"
                                }}
                              >
                                {inventory?.pnr || "-"}
                              </span>
                            </td>

                            {/* Dept. Date */}
                            <td style={{ padding: "10px 12px", whiteSpace: "nowrap" }}>
                              <span
                                style={{
                                  fontSize: "11px",
                                  color: "#6b7280",
                                  fontWeight: "600",
                                  background: "#f4f6fb",
                                  borderRadius: "6px",
                                  padding: "2px 8px"
                                }}
                              >
                                <i className="bi bi-calendar3 me-1" style={{ color: "#8a9ab5" }}></i>
                                {inventory?.dep_date || "-"}
                              </span>
                            </td>

                            {/* Seats */}
                            <td style={{ padding: "10px 12px" }}>
                              <span
                                style={{
                                  background: "#ecfdf5",
                                  color: "#065f46",
                                  borderRadius: "6px",
                                  padding: "3px 8px",
                                  fontSize: "11px",
                                  fontWeight: "700"
                                }}
                              >
                                <i className="bi bi-person-fill me-1" style={{ fontSize: "10px" }}></i>
                                {inventory?.seat_quantity ?? 0}
                              </span>
                            </td>

                            {/* Fare */}
                            <td style={{ padding: "10px 12px", whiteSpace: "nowrap" }}>
                              <button
                                type="button"
                                style={{
                                  background: "#eef0ff",
                                  border: "none",
                                  borderRadius: "7px",
                                  width: "28px",
                                  height: "28px",
                                  padding: 0,
                                  marginRight: "4px"
                                }}
                                data-bs-toggle="modal"
                                data-bs-target="#ViewFare"
                                title="View Fare"
                                onMouseEnter={(e) => (e.currentTarget.style.background = "#dde3ef")}
                                onMouseLeave={(e) => (e.currentTarget.style.background = "#eef0ff")}
                              >
                                <i className="bi bi-eye-fill" style={{ fontSize: "11px", color: "#1a3a8f" }}></i>
                              </button>
                              <button
                                type="button"
                                style={{
                                  background: "#fffbeb",
                                  border: "none",
                                  borderRadius: "7px",
                                  width: "28px",
                                  height: "28px",
                                  padding: 0
                                }}
                                data-bs-toggle="modal"
                                data-bs-target="#UpdateFare"
                                title="Update Fare"
                                onMouseEnter={(e) => (e.currentTarget.style.background = "#fef3c7")}
                                onMouseLeave={(e) => (e.currentTarget.style.background = "#fffbeb")}
                              >
                                <i className="bi bi-pencil-fill" style={{ fontSize: "11px", color: "#b45309" }}></i>
                              </button>
                            </td>

                            {/* +/- Seat */}
                            <td style={{ padding: "10px 12px" }}>
                              <button
                                type="button"
                                style={{
                                  background: "#ecfdf5",
                                  border: "none",
                                  borderRadius: "7px",
                                  width: "28px",
                                  height: "28px",
                                  padding: 0
                                }}
                                data-bs-toggle="modal"
                                data-bs-target="#AddUpdateSeat"
                                title="Add / Remove Seats"
                                onMouseEnter={(e) => (e.currentTarget.style.background = "#d1fae5")}
                                onMouseLeave={(e) => (e.currentTarget.style.background = "#ecfdf5")}
                              >
                                <i className="bi bi-pencil-square" style={{ fontSize: "11px", color: "#065f46" }}></i>
                              </button>
                            </td>

                            {/* Action */}
                            <td style={{ padding: "10px 12px", whiteSpace: "nowrap" }}>
                              <button
                                className="btn btn-sm me-1"
                                style={{
                                  background: "#eef0ff",
                                  color: "#1a3a8f",
                                  border: "none",
                                  borderRadius: "7px",
                                  width: "28px",
                                  height: "28px",
                                  padding: 0
                                }}
                                title="Edit"
                                onClick={() => openActionModal("edit", inventory)}
                              >
                                <i className="bi bi-pencil-fill" style={{ fontSize: "11px" }}></i>
                              </button>

                              <button
                                className="btn btn-sm me-1"
                                style={{
                                  background: "#ecfdf5",
                                  color: "#065f46",
                                  border: "none",
                                  borderRadius: "7px",
                                  width: "28px",
                                  height: "28px",
                                  padding: 0
                                }}
                                title="Refresh"
                                onClick={() => openActionModal("refresh", inventory)}
                              >
                                <i className="bi bi-arrow-clockwise" style={{ fontSize: "11px" }}></i>
                              </button>

                              <button
                                className="btn btn-sm"
                                style={{
                                  background: "#fff1f1",
                                  color: "#dc2626",
                                  border: "none",
                                  borderRadius: "7px",
                                  width: "28px",
                                  height: "28px",
                                  padding: 0
                                }}
                                title="Delete"
                                onClick={() => openActionModal("delete", inventory)}
                              >
                                <i className="bi bi-trash-fill" style={{ fontSize: "11px" }}></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="11" className="text-center py-5">
                            <div style={{ color: "#8a9ab5" }}>
                              <i
                                className="bi bi-inbox"
                                style={{ fontSize: "36px", display: "block", marginBottom: "8px" }}
                              ></i>
                              <span style={{ fontSize: "13px" }}>No inventory found</span>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                <div className="d-flex align-items-center justify-content-between py-3" style={{ borderTop: "1px solid #f0f2f8" }}>
                  <div className="d-flex align-items-center gap-2">
                    <select className="form-select form-select-sm" id="paginationRows" onChange={handlePagingLimit}
                      style={{ width: "75px", borderRadius: "8px", border: "1.5px solid #dde3ef", fontSize: "12px" }}>
                      {["10", "20", "50", "100", "500"].map(v => (
                        <option key={v} value={v} selected={pagingLimit === v}>{v}</option>
                      ))}
                    </select>
                    <span style={{ fontSize: "12px", color: "#8a9ab5", whiteSpace: "nowrap" }}>Records per page</span>
                  </div>
                  <ul className="pagination pagination-sm mb-0 gap-1">
                    <li className={`page-item ${pageValue === 1 ? "disabled" : ""}`}>
                      <Link className="page-link" onClick={() => handlePagination(pageValue - 1)}
                        style={{ borderRadius: "7px", border: "1.5px solid #dde3ef", color: "#1a3a8f", fontSize: "12px", padding: "4px 10px" }}>
                        <i className="fa-solid fa-angle-left"></i>
                      </Link>
                    </li>
                    {Array.from({ length: inventoryRes?.paginationInfo?.totalPage }, (_, i) => (
                      <li className="page-item" key={i}>
                        <Link className="page-link" onClick={() => handlePagination(i + 1)}
                          style={{
                            borderRadius: "7px", fontSize: "12px", padding: "4px 10px",
                            border: pageValue === i + 1 ? "none" : "1.5px solid #dde3ef",
                            background: pageValue === i + 1 ? "linear-gradient(135deg, #0f2557, #1a3a8f)" : "white",
                            color: pageValue === i + 1 ? "white" : "#374151",
                            fontWeight: pageValue === i + 1 ? "700" : "400"
                          }}>
                          {i + 1}
                        </Link>
                      </li>
                    ))}
                    <li className={`page-item ${pageValue === inventoryRes?.paginationInfo?.totalPage ? "disabled" : ""}`}>
                      <Link className="page-link" onClick={() => handlePagination(pageValue + 1)}
                        style={{ borderRadius: "7px", border: "1.5px solid #dde3ef", color: "#1a3a8f", fontSize: "12px", padding: "4px 10px" }}>
                        <i className="fa-solid fa-angle-right"></i>
                      </Link>
                    </li>
                  </ul>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── View Fare Modal ── */}
      <div className="modal fade" id="ViewFare" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content border-0 shadow" style={{ borderRadius: "16px", overflow: "hidden" }}>
            <div style={{ height: "4px", background: "linear-gradient(135deg, #0f2557, #1a3a8f)" }}></div>
            <div className="modal-header border-0 pb-0 px-4 pt-4">
              <div className="d-flex align-items-center gap-3">
                <div style={{ width: "38px", height: "38px", borderRadius: "10px", background: "linear-gradient(135deg, #0f2557, #1a3a8f)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <i className="bi bi-eye-fill text-white" style={{ fontSize: "15px" }}></i>
                </div>
                <div>
                  <h6 className="mb-0 fw-bold" style={{ color: "#0f2557", fontSize: "15px" }}>Fare Details</h6>
                  <p className="mb-0" style={{ fontSize: "11px", color: "#8a9ab5" }}>View current fare slabs</p>
                </div>
              </div>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body px-4 pb-4">
              <table className="table mb-0" style={{ fontSize: "13px" }}>
                <thead>
                  <tr style={{ background: "#f4f6fb" }}>
                    {["Fare", "Sold Seat", "Unsold Seat", "Total Seat", "Departure Date"].map((h, i) => (
                      <th key={i} style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px", border: "none", padding: "10px 12px", background: "#f4f6fb" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {[1, 2].map((_, i) => (
                    <tr key={i} style={{ borderBottom: "1px solid #f0f2f8", verticalAlign: "middle" }}>
                      <td style={{ padding: "10px 12px" }}>
                        <span style={{ background: "#ecfdf5", color: "#065f46", borderRadius: "6px", padding: "3px 8px", fontSize: "12px", fontWeight: "700" }}>₹ 5,000</span>
                      </td>
                      <td style={{ padding: "10px 12px", color: "#374151", fontWeight: "600" }}>5</td>
                      <td style={{ padding: "10px 12px", color: "#374151", fontWeight: "600" }}>5</td>
                      <td style={{ padding: "10px 12px" }}>
                        <span style={{ background: "#eef0ff", color: "#1a3a8f", borderRadius: "6px", padding: "2px 8px", fontSize: "11px", fontWeight: "700" }}>10</span>
                      </td>
                      <td style={{ padding: "10px 12px" }}>
                        <span style={{ fontSize: "11px", color: "#6b7280", fontWeight: "600", background: "#f4f6fb", borderRadius: "6px", padding: "2px 8px" }}>
                          <i className="bi bi-calendar3 me-1" style={{ color: "#8a9ab5" }}></i>31 July 2025
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* ── Update Fare Modal ── */}
      <div className="modal fade" id="UpdateFare" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content border-0 shadow" style={{ borderRadius: "16px", overflow: "hidden" }}>
            <div style={{ height: "4px", background: "linear-gradient(135deg, #0f2557, #1a3a8f)" }}></div>
            <div className="modal-header border-0 pb-0 px-4 pt-4">
              <div className="d-flex align-items-center gap-3">
                <div style={{ width: "38px", height: "38px", borderRadius: "10px", background: "linear-gradient(135deg, #0f2557, #1a3a8f)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <i className="bi bi-pencil-fill text-white" style={{ fontSize: "15px" }}></i>
                </div>
                <div>
                  <h6 className="mb-0 fw-bold" style={{ color: "#0f2557", fontSize: "15px" }}>Update Fare</h6>
                  <p className="mb-0" style={{ fontSize: "11px", color: "#8a9ab5" }}>Modify fare details for this PNR</p>
                </div>
              </div>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body px-4 pb-4">

              {/* PNR + Warning */}
              <div className="row g-2 mb-3">
                <div className="col-md-4">
                  <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>PNR Number</label>
                  <div className="input-group input-group-sm">
                    <span className="input-group-text" style={{ background: "#eef0ff", border: "1.5px solid #dde3ef", borderRight: "none", borderRadius: "8px 0 0 8px" }}>
                      <i className="bi bi-upc" style={{ color: "#1a3a8f", fontSize: "12px" }}></i>
                    </span>
                    <input type="text" className="form-control form-control-sm" id="txtUpdate_PnrNumber" value="GFg123" readOnly
                      style={{ border: "1.5px solid #dde3ef", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "#f8f9fe", fontSize: "13px", fontWeight: "700" }} />
                  </div>
                </div>
                <div className="col-md-8 d-flex align-items-end">
                  <div className="d-flex align-items-center gap-2 p-2 rounded-3 w-100" style={{ background: "#fff1f1", border: "1.5px solid #fca5a5" }}>
                    <i className="bi bi-exclamation-circle-fill" style={{ color: "#dc2626", fontSize: "13px", flexShrink: 0 }}></i>
                    <span style={{ fontSize: "11px", color: "#dc2626", fontWeight: "500" }}>Please select fare slab first, before new update!</span>
                  </div>
                </div>
              </div>

              {/* Existing Info */}
              <div className="p-3 mb-3 rounded-3" style={{ background: "#f8f9fe", border: "1px solid #eef0f8" }}>
                <div className="d-flex align-items-center gap-2 mb-3">
                  <i className="bi bi-info-circle-fill" style={{ color: "#1a3a8f", fontSize: "13px" }}></i>
                  <span style={{ fontSize: "11px", fontWeight: "700", color: "#1a3a8f", textTransform: "uppercase", letterSpacing: "0.7px" }}>Existing Info</span>
                </div>
                <div className="row g-2">
                  {[
                    { id: "txtUpdate_FareSlab", label: "Fare Slab", type: "select", options: [{ v: "5000", l: "₹ 5,000" }] },
                    { id: "txtUpdate_SeatLeft", label: "Seat Left", type: "text", value: 0, readOnly: true },
                    { id: "txtUpdate_SeatSold", label: "Seat Sold", type: "text", value: 0, readOnly: true },
                    { id: "txtUpdate_InfantFare", label: "Infant Fare", type: "text", value: 0, readOnly: true },
                    { id: "txtUpdate_TotalFare", label: "Total Fare", type: "text", value: 0, readOnly: true },
                    { id: "txtUpdate_TotalMarkupFare", label: "Markup Fare", type: "text", value: 0, readOnly: true },
                  ].map(({ id, label, type, options, value, readOnly }) => (
                    <div className="col-md-4" key={id}>
                      <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>{label}</label>
                      {type === "select" ? (
                        <select className="form-select form-select-sm" id={id}
                          style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", fontSize: "13px" }}>
                          <option value="">Select</option>
                          {options.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
                        </select>
                      ) : (
                        <input type="text" className="form-control form-control-sm" id={id} value={value} readOnly={readOnly}
                          style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", background: readOnly ? "#f8f9fe" : "white", fontSize: "13px" }} />
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {/* New Fare */}
              <div className="p-3 rounded-3" style={{ background: "#f8f9fe", border: "1px solid #eef0f8" }}>
                <div className="d-flex align-items-center gap-2 mb-3">
                  <i className="bi bi-pencil-square" style={{ color: "#1a3a8f", fontSize: "13px" }}></i>
                  <span style={{ fontSize: "11px", fontWeight: "700", color: "#1a3a8f", textTransform: "uppercase", letterSpacing: "0.7px" }}>New Fare</span>
                </div>
                <div className="row g-2 align-items-end">
                  {[
                    { id: "txtUpdate_SelectSeat", label: "Seat", type: "select", options: [1, 2, 3, 4].map(v => ({ v, l: v })), col: 2 },
                    { id: "txtUpdate_BasicFare", label: "Basic Fare", type: "text", value: 0, col: 2 },
                    { id: "txtUpdate_YQFare", label: "YQ Fare", type: "text", value: 0, col: 2 },
                    { id: "txtUpdate_YRFare", label: "YR Fare", type: "text", value: 0, col: 2 },
                    { id: "txtUpdate_OTFare", label: "OT Fare", type: "text", value: 0, col: 2 },
                    { id: "txtUpdate_InfantFareNew", label: "Infant Fare", type: "text", value: 0, col: 3 },
                    { id: "txtUpdate_GrandTotalFare", label: "Grand Total", type: "text", value: 0, readOnly: true, col: 3 },
                  ].map(({ id, label, type, options, value, readOnly, col }) => (
                    <div className={`col-md-${col}`} key={id}>
                      <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>{label}</label>
                      {type === "select" ? (
                        <select className="form-select form-select-sm" id={id}
                          style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", fontSize: "13px" }}>
                          <option value="">Select</option>
                          {options.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
                        </select>
                      ) : (
                        <input type="text" className="form-control form-control-sm" id={id} value={value} readOnly={readOnly}
                          style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", background: readOnly ? "#f8f9fe" : "white", fontSize: "13px" }} />
                      )}
                    </div>
                  ))}
                  <div className="col-md-3 d-flex align-items-end">
                    <button type="submit" className="btn btn-sm fw-semibold d-flex align-items-center gap-2 text-white w-100 justify-content-center"
                      style={{ background: "linear-gradient(135deg, #0f2557, #1a3a8f)", borderRadius: "8px", border: "none", boxShadow: "0 4px 12px rgba(15,37,87,0.25)", fontSize: "13px", height: "34px" }}>
                      <i className="bi bi-floppy-fill"></i> Update
                    </button>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* ── Add/Update Seat Modal ── */}
      <div className="modal fade" id="AddUpdateSeat" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content border-0 shadow" style={{ borderRadius: "16px", overflow: "hidden" }}>
            <div style={{ height: "4px", background: "linear-gradient(135deg, #0f2557, #1a3a8f)" }}></div>
            <div className="modal-header border-0 pb-0 px-4 pt-4">
              <div className="d-flex align-items-center gap-3">
                <div style={{ width: "38px", height: "38px", borderRadius: "10px", background: "linear-gradient(135deg, #0f2557, #1a3a8f)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <i className="bi bi-person-lines-fill text-white" style={{ fontSize: "15px" }}></i>
                </div>
                <div>
                  <h6 className="mb-0 fw-bold" style={{ color: "#0f2557", fontSize: "15px" }}>Seat Details</h6>
                  <p className="mb-0" style={{ fontSize: "11px", color: "#8a9ab5" }}>Add or decrease seats for PNR</p>
                </div>
              </div>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body px-4 pb-4">

              {/* Add Seat Section */}
              <div className="p-3 mb-3 rounded-3" style={{ background: "#f8f9fe", border: "1px solid #eef0f8" }}>
                <div className="d-flex align-items-center gap-2 mb-3">
                  <i className="bi bi-plus-circle-fill" style={{ color: "#065f46", fontSize: "13px" }}></i>
                  <span style={{ fontSize: "11px", fontWeight: "700", color: "#065f46", textTransform: "uppercase", letterSpacing: "0.7px" }}>Add New Seat</span>
                  <span style={{ fontSize: "10px", fontWeight: "700", background: "#eef0ff", color: "#1a3a8f", borderRadius: "5px", padding: "1px 7px" }}>PNR: ABC123</span>
                </div>
                <div className="row g-2 align-items-end">
                  {[
                    { id: "txtUpdate_AddSeat_SeatNumber", label: "Seat No.", value: "0", col: 2 },
                    { id: "txtUpdate_AddSeat_BasicFare", label: "Basic Fare", value: "0", col: 2 },
                    { id: "txtUpdate_AddSeat_YQFare", label: "YQ Fare", value: "0", col: 2 },
                    { id: "txtUpdate_AddSeat_YRFare", label: "YR Fare", value: "0", col: 2 },
                    { id: "txtUpdate_AddSeat_OTFare", label: "OT Fare", value: "0", col: 2 },
                    { id: "txtUpdate_AddSeat_InfantFare", label: "Infant Fare", value: "0", col: 3 },
                    { id: "txtUpdate_AddSeat_GrandTotalFare", label: "Grand Total", value: "0", readOnly: true, col: 3 },
                  ].map(({ id, label, value, readOnly, col }) => (
                    <div className={`col-md-${col}`} key={id}>
                      <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>{label}</label>
                      <input type="text" className="form-control form-control-sm" id={id} value={value} readOnly={readOnly}
                        style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", background: readOnly ? "#f8f9fe" : "white", fontSize: "13px" }} />
                    </div>
                  ))}
                  <div className="col-md-3 d-flex align-items-end">
                    <button type="submit" className="btn btn-sm fw-semibold d-flex align-items-center gap-2 text-white w-100 justify-content-center"
                      style={{ background: "linear-gradient(135deg, #065f46, #10b981)", borderRadius: "8px", border: "none", boxShadow: "0 4px 12px rgba(6,95,70,0.25)", fontSize: "13px", height: "34px" }}>
                      <i className="bi bi-plus-circle-fill"></i> Add Seat
                    </button>
                  </div>
                </div>
              </div>

              {/* Decrease Seat Section */}
              <div className="p-3 rounded-3" style={{ background: "#f8f9fe", border: "1px solid #eef0f8" }}>
                <div className="d-flex align-items-center gap-2 mb-3">
                  <i className="bi bi-dash-circle-fill" style={{ color: "#dc2626", fontSize: "13px" }}></i>
                  <span style={{ fontSize: "11px", fontWeight: "700", color: "#dc2626", textTransform: "uppercase", letterSpacing: "0.7px" }}>Decrease Seat</span>
                  <span style={{ fontSize: "10px", fontWeight: "700", background: "#eef0ff", color: "#1a3a8f", borderRadius: "5px", padding: "1px 7px" }}>PNR: ABC123</span>
                </div>
                <div className="row g-2 align-items-end">
                  <div className="col-md-3">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>Select Fare</label>
                    <select className="form-select form-select-sm" id="txtUpdate_MinusSeat_SelectSeat"
                      style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", fontSize: "13px" }}>
                      <option value="">Select</option>
                      <option value="5000">₹ 5,000</option>
                      <option value="2000">₹ 2,000</option>
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>Seat Left</label>
                    <input type="text" className="form-control form-control-sm" id="txtUpdate_MinusSeat_SeatLeft" value="0" readOnly
                      style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", background: "#f8f9fe", fontSize: "13px" }} />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>Seats to Decrease</label>
                    <select className="form-select form-select-sm" id="txtUpdate_MinusSeat_MinusSelectSeat"
                      style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", fontSize: "13px" }}>
                      <option value="">Select</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                    </select>
                  </div>
                  <div className="col-md-3 d-flex align-items-end">
                    <button type="submit" className="btn btn-sm fw-semibold d-flex align-items-center gap-2 text-white w-100 justify-content-center"
                      style={{ background: "linear-gradient(135deg, #991b1b, #dc2626)", borderRadius: "8px", border: "none", boxShadow: "0 4px 12px rgba(220,38,38,0.25)", fontSize: "13px", height: "34px" }}>
                      <i className="bi bi-dash-circle-fill"></i> Decrease Seat
                    </button>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ListInventory